export default __webpack_public_path__ + "static/header-iconic-link-products-link-icon4.url-a33d1adec534560ab6364638b834b53e.svg";